import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/district-templates/{id}/document-configs/{configId}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

/** Updates an existing document config within a district template. */
const updateDistrictDocumentConfig = async ({ id, configId, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/district-templates/{id}/document-configs/{configId}', { id, configId });
  const response = await noodleApiClient.put(path, body);
  return response.data;
};

export default updateDistrictDocumentConfig;
